import { render, staticRenderFns } from "./AutobuyersTab.vue?vue&type=template&id=1f979c50&scoped=true"
import script from "./AutobuyersTab.vue?vue&type=script&lang=js"
export * from "./AutobuyersTab.vue?vue&type=script&lang=js"
import style0 from "./AutobuyersTab.vue?vue&type=style&index=0&id=1f979c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f979c50",
  null
  
)

export default component.exports